import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../config";
import activeDiscount from "../helpers/activeDiscount";
import calculatePrice from "../helpers/calculatePrice";

export default class CartItem extends Component {
  state = { remove: false, delete: false };

  render() {
    const discount = activeDiscount(this.props.product.categories);

    return (
      <tr
        className={this.state.remove ? `cart-item remove` : "cart-item"}
        style={
          !this.state.remove
            ? {
                transform: "none",
                transition: "none",
              }
            : {}
        }
      >
        <td className="product-thumb">
          <Link
            to={{
              pathname: `/urun/${this.props.product.slug}`,
              state: { product: this.props.product },
            }}
          >
            <img
              alt={this.props.product.name}
              src={PUBLIC_URL(this.props.product.image)}
            />
          </Link>
        </td>
        <td className="product-name">
          <Link
            to={{
              pathname: `/urun/${this.props.product.slug}`,
              state: { product: this.props.product },
            }}
          >
            {this.props.product.name}
          </Link>
        </td>
        <td>
          <span
            style={{
              color: discount ? "#ccc" : "#000",
              textDecoration: discount ? "line-through" : "none",
            }}
          >
            ₺
            {this.props.product.sale_price
              ? parseFloat(this.props.product.sale_price).toFixed(2)
              : parseFloat(this.props.product.price).toFixed(2)}
          </span>
          {discount ? (
            <React.Fragment>
              <br />₺
              {discount.type === "percent"
                ? this.props.product.sale_price
                  ? parseFloat(
                      this.props.product.sale_price *
                        (1 - discount.discount / 100)
                    ).toFixed(2)
                  : parseFloat(
                      this.props.product.price * (1 - discount.discount / 100)
                    ).toFixed(2)
                : this.props.product.sale_price
                ? parseFloat(
                    this.props.product.sale_price - discount.discount
                  ).toFixed(2)
                : parseFloat(
                    this.props.product.price - discount.discount
                  ).toFixed(2)}
            </React.Fragment>
          ) : null}
        </td>
        <td className="product-quantity">
          <ul>
            <li>
              <button
                type="button"
                disabled={this.props.product.quantity === 1}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.decCart();
                }}
              >
                <FontAwesomeIcon icon={["fas", "minus"]} />
              </button>
            </li>
            <li className={"quantity"}>
              <input
                type={"text"}
                defaultValue={this.props.product.quantity}
                value={this.props.product.quantity}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === "") value = "1";
                  value = value.replace(/[^0-9]+/g, "");
                  if (value < 1) value = 1;
                  this.props.updateCartQuantity(parseInt(value));
                }}
              />
              <span>Adet</span>
            </li>
            <li>
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.incCart();
                }}
              >
                <FontAwesomeIcon icon={["fas", "plus"]} />
              </button>
            </li>
          </ul>
        </td>
        <td>₺{calculatePrice(this.props.product, discount)}</td>
        <td className="product-status">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (
                window.confirm(
                  `${this.props.product.name} ürününü sepetinizden çıkartmak istediğinize eminmisiniz?`
                )
              ) {
                this.setState({ remove: true }, () => {
                  setTimeout(() => {
                    this.props.removeCart();
                    this.setState({ remove: false });
                  }, 500);
                });
              }
            }}
          >
            <FontAwesomeIcon icon={["fas", "times"]} />
          </a>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CartItem.js